module.exports = __webpack_public_path__ + "img/hr-tree-03-e-trunk.8048a15d.png";